<template>
    <div class='spaceCenter common common-form-inline'>
        <a-form-model
        style="width:400px"
        ref="ruleForm"
        :model="pageData"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        >
            <a-form-model-item label="请输入新密码" prop="newPswd">
                <a-input v-model="pageData.newPswd" type="password"/>
            </a-form-model-item>
            <a-form-model-item label="请再次输入新密码" prop="confirmPswd">
                <a-input v-model="pageData.confirmPswd" type="password"/>
                <div class="text-size-12 text-color-red" style="position:absolute;white-space: nowrap;">{{errMsg}}</div>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
import {getUserInfo,getApproveInfoByAprvId,checkUser,getCaptcha,setNewPwd} from "@/api/security.js"
export default {
    props:["passwordType","noInit"], //passwordType = undefined：登录密码  txnpswd:交易密码 /  noInit = true:忘记密码页面  false:修改密码 
    name:"user-modify",
    data() {
        return {
            labelCol: { span: 9 },
            wrapperCol: { span: 15 },
            pageData:{
                newPswd:"",
                confirmPswd:""
            },
            rules:{
                newPswd:{
                    required: true,
                    trigger: "blur",
                    whitespace:true,
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            cbfn('请输入新密码');
                        } 
                        else if(!this.utils.regExpObj.PASSWORD_PATTERN.test(value)) {
                            cbfn('字母/数字/特殊字符(~!@#$%^&*()_.)中至少两种组成，8-16位');
                        }
                        else{
                            cbfn();
                        }
                    }
                },
                confirmPswd:{
                    required: true,
                    trigger: "blur",
                    whitespace:true,
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            cbfn('请再次输入新密码');
                        } 
                        else if(!this.utils.regExpObj.PASSWORD_PATTERN.test(value)) {
                            cbfn('字母/数字/特殊字符(~!@#$%^&*()_.)中至少两种组成，8-20位');
                        }
                        else if(value != this.pageData.newPswd){
                            cbfn('两次输入密码不一致');
                        }
                        else{
                            cbfn();
                        }
                    }
                }
            },
            errMsg:""
        };
    },
    computed: {},
    methods: {
        check(){
            return new Promise((resolve,reject) => {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        const params = {
                            mobileOrEmail:this.$store.getters["app/getModfyMobileOrEmail"],
                            loginName:this.$store.getters["home/getUserHeader"].loginName,
                            newPswd:this.utils.getPasswordEncryptString(this.pageData.newPswd),
                            type: this.passwordType=='txnpswd' ? "1" : undefined,
                        };
                        setNewPwd(params,true).then(res => {
                            resolve(res);
                        }).catch(err => {
                            this.errMsg = err.description;
                            reject(err);
                        })
                    } else {
                        return false;
                    }
                });
            })  
        }
    },
    created() {
       
    },
    mounted() {},
    watch: {}
}
</script>
<style scoped>
.common-form-inline{
    margin: 40px 0;
}
.input-box{
    position: relative;
}
.input-btn{
    position: absolute;
    right: 5px;
    top: 8px;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/steps/password-modify.vue